// third-party
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';

// types
import { DefaultRootStateProps } from 'types';

const initialState: DefaultRootStateProps['chatGpt'] = {
    loading: false,
    updating: false,
    error: null,
    messageChat: null
};

const slice = createSlice({
    name: 'chatGpt',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(sendMessage.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendMessage.fulfilled, (state, action) => {
                state.loading = false;
                state.messageChat = action.payload.response;
            })
            .addCase(generateImages.pending, (state) => {
                state.loading = true;
            })
            .addCase(generateImages.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(generateImages.rejected, (state) => {
                state.loading = false;
            });
    }
});
export default slice.reducer;

interface DataIA {
    request: string;
    language: string;
    data: {
        name: string;
        brand: string;
        category: string;
    };
}
interface DataSpell {
    msg: string;
}
interface DataRegionalization {
    country: string;
    msg: string;
}

interface IGenerateDataWithImage {
    images: string[];
    language: string;
    requestData: string[];
    country: string;
}
interface IDataGenerateImage {
    name: string;
    brand: string;
    category: string;
    description: string;
}
export const sendMessage = createAsyncThunk(`${slice.name}/send-message`, async (dataIA: DataIA) => {
    const dataMessage = dataIA?.data;
    const solic = dataIA?.request;
    const language = dataIA?.language;
    const response = await axios.post(`/loolu/api/genAI/text/${solic}?language=${language}`, dataMessage);
    return response.data;
});

export const spellCorrectionCheck = createAsyncThunk(`${slice.name}/spell-correction`, async (dataIA: DataSpell) => {
    const dataMessage = dataIA?.msg;
    const response = await axios.post(`/loolu/api/genAI/text/spelling`, { rawText: dataMessage });
    return response.data;
});

export const regionalizationCheck = createAsyncThunk(`${slice.name}/spell-correction`, async (dataIA: DataRegionalization) => {
    const dataMessage = dataIA?.msg;
    const country = dataIA?.country;
    const response = await axios.post(`/loolu/api/genAI/text/translate?country=${country}`, {
        text: dataMessage
    });
    return response.data;
});

export const generateDataWithImages = createAsyncThunk(`${slice.name}/image`, async (dataIA: IGenerateDataWithImage) => {
    const language = dataIA.language;

    const response = await axios.post(`/loolu/api/genAI/image?language=${language}&country=${dataIA.country}`, {
        imageLink: dataIA.images,
        requestData: dataIA.requestData
    });
    return response.data;
});

export const generateImages = createAsyncThunk(`${slice.name}/image/generation`, async (dataIA: IDataGenerateImage) => {
    const response = await axios.post(`/loolu/api/genAI/image/generation`, dataIA);
    return response.data;
});
